import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  &:not(&:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing.x3};
  }
`;

export default styled.div`
  ${({ theme: { space } }) => css`
    display: flex;
    align-items: center;
    width: 100%;

    margin: -${({ theme }) => theme.spacing.x2};
    > * {
      margin: ${({ theme }) => theme.spacing.x1};
      width: 50%;
    }

    &:not(&:last-child) {
      margin-bottom: ${space.md};
    }

    .input-container,
    .input-select-container {
      flex: 1;
      &:not(&:last-child) {
        margin-inline-end: ${space.lg};
      }
    }

    .input-select-container {
      .input-container {
        &:not(&:last-child) {
          margin: 0;
        }
      }
    }
  `}
`;
